import React, { useState } from "react";
import { FicCheckbox, FicDatePicker } from "../../Utils/FormInputComponents";
import Banner from "../common/Banner";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import GenBtn from "../../components/GenBtn";
import InputsContainer from "../common/InputsContainer";
import { crear } from "./actions";
import LoadMask from "../../Utils/LoadMask/LoadMask";
import { withRouter } from "react-router";
import { startOfMonth, endOfMonth, parseDate } from "@internationalized/date";
import useUpdateEffect from "../../../../hooks/useUpdateEffect";
import { processFormData } from "./helpers";

const BANNER_TEXT = "Crear periodo";

const schema = yup.object({
    fecha_periodo: yup.string().required("El mes y año es requerido"),
});

function Crear({ history, ...props }) {
    const [isLoading, setIsLoading] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const { control, reset, handleSubmit, watch } = useForm({
        mode: "onChange",
        resolver: yupResolver(schema),
        defaultValues: {
            fecha_periodo: null,
            estado: true
        },
    });

    async function onSubmit(data) {
        setIsLoading(true);
        data.fecha_inicio = fechaInicio;
        data.fecha_fin = fechaFin;
        await crear(processFormData(data));
        setIsLoading(false);
    }

    const selectedDate = watch("fecha_periodo");

    useUpdateEffect(() => {
        if (selectedDate) {
            const date = parseDate(selectedDate);
            const firstDay = startOfMonth(date);
            const lastDay = endOfMonth(date);
            setFechaInicio(firstDay);
            setFechaFin(lastDay);
        }
    }, [selectedDate]);

    return (
        <React.Fragment>
            <Banner>{BANNER_TEXT}</Banner>
            <GenBtn
                onPress={() => history.goBack()}
                style={{ margin: "5px 0" }}
            >
                Regresar
            </GenBtn>
            <LoadMask loading={isLoading} color="#bd0034" blur={true}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <InputsContainer>
                        <FicDatePicker
                            control={control}
                            label="Mes y año"
                            name="fecha_periodo"
                            granularity="month"
                            noBtn
                        />
                        <FicDatePicker
                            nonForm
                            label="Fecha de inicio"
                            name="fecha_inicio"
                            value={fechaInicio}
                            noBtn
                            isDisabled
                        />
                            <FicDatePicker
                                nonForm
                                label="Fecha final"
                                name="fecha_fin"
                                value={fechaFin}
                                noBtn
                                isDisabled
                            />
                        <FicCheckbox
                            control={control}
                            label="Activo?"
                            name="estado"
                        />
                    </InputsContainer>
                    <GenBtn style={{ margin: "1rem 0" }} type="submit">
                        Guardar
                    </GenBtn>
                </form>
            </LoadMask>
        </React.Fragment>
    );
}
export default withRouter(Crear);
